import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CalendarCheck } from 'lucide-react';

const HIDDEN_PREFIXES = ['/booking', '/admin', '/my-account', '/gift-cards/checkout', '/membership/checkout'];

// Mobile-only sticky CTA — every extra tap costs bookings, so keep "Book now" one thumb away.
const StickyBookNow = () => {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;
  return (
    <>
      {/* Spacer so the fixed bar never covers the footer's last lines */}
      <div className="md:hidden h-20" aria-hidden="true" />
      <div className="md:hidden fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2 pointer-events-none" data-testid="sticky-book-now">
      <Link
        to="/booking"
        className="pointer-events-auto flex items-center justify-center gap-2 w-full rounded-full bg-beauty-black text-white text-sm font-semibold py-3.5 shadow-[0_8px_30px_rgba(0,0,0,0.25)] active:scale-[0.98] transition-transform"
        data-testid="sticky-book-now-link"
      >
        <CalendarCheck className="w-4 h-4" aria-hidden="true" />
        Book now · live availability
      </Link>
      </div>
    </>
  );
};

export default StickyBookNow;
